module.exports = __webpack_public_path__ + "img/MoonSword 5b.bad53802.png";